module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./CheckOrderView.js"));
	}, "CheckOrderView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CheckOrderView!./src/pages/Shop/CheckOrder/CheckOrderView.js
// module id = 1360
// module chunks = 418